import { IconButton, Popover, Portal, useBreakpointValue, useDisclosure } from "@chakra-ui/react"
import { cloneElement, PropsWithChildren, useEffect } from "react"
import { PiListBold, PiXBold } from "react-icons/pi"

export const MobilePopover = (props: PropsWithChildren) => {
  const { open, onOpen, onClose } = useDisclosure()

  //Offset breakpoints for the popover
  const offsetValue = useBreakpointValue({ base: 15, sm: 50 })

  function useBodyScrollLock(locked: boolean) {
    useEffect(() => {
      if (locked) {
        const previous = document.body.style.overflow
        document.body.style.overflow = "hidden"

        return () => {
          document.body.style.overflow = previous
        }
      }
    }, [locked])
  }

  useBodyScrollLock(open)

  return (
    <Popover.Root
      open={open}
      positioning={{ 
        placement: "bottom", 
        overflowPadding: 0,
        offset: { mainAxis: offsetValue },
      }}
    >
      <Popover.Trigger asChild>
        <IconButton
          aria-label="Open Menu"
          variant="ghost"
          hideFrom="md"
          color="main"
          pos="absolute"
          right={{ base: "1", sm: "10" }}
          onClick={open ? onClose : onOpen}
        >
          {open ? <PiXBold size={50} /> : <PiListBold size={50} />}
        </IconButton>
      </Popover.Trigger>

      <Portal>
        <Popover.Positioner>
          <Popover.Content
            textStyle="md"
            hideFrom="md"
            boxShadow="none"
            borderRadius="none"
            width="var(--available-width)"
            height="var(--available-height)"
            px="4"
            py="6"
            overflowY="auto"
            css={{ WebkitOverflowScrolling: "touch" }}
          >
            {cloneElement(props.children as any, {
              onNavClick: onClose
            })}
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  )
}
